<template>
    <div :style="basicContentStyles">
        <thumbnail :preview-url="this.data.background_image"/>
        <div v-if="data.state !== 'unknown'" :class="[data.state, 'state']">
            <i v-if="data.state === 'link'" class="fa-regular fa-link-simple" aria-hidden="true"></i>
            <i v-else class="fa-regular fa-link-simple-slash" aria-hidden="true"></i>
        </div>
    </div>
</template>

<script>
    import thumbnail from "../common/thumb-autoupdate";

    export default {
        props: ['data', 'frame', 'basicContentStyles', 'width', 'height'],
        components: {
            thumbnail,
        },
        computed: {
            elementStyles: function () {
                let opacity = 1;
                if (!isNaN(this.data.transparency)) {
                    opacity -= this.data.transparency/100;
                }
                // 0.999: such that border when selected is visualized correctly.
                opacity = Math.min(opacity, 0.999);

                return {
                    backgroundImage: 'url("' + this.data.background_image + '")',
                    backgroundSize: '100% 100%',
                    opacity: opacity,
                }
            }
        }
    }
</script>
